<template>
  <VBusHelper :emitOnMounted="$constants.EVENTS.COUPONS.LIST_ALL.REFRESH" />

  <CouponsLoadingError
    v-if="$stores.coupons?.state?.list_all?.error"
    @refresh="() => $bus.emit($constants.EVENTS.COUPONS.LIST_ALL.REFRESH)"
  >
    <template #errorDescription>
      {{ $stores.coupons?.state?.list_all?.error }}
    </template>
  </CouponsLoadingError>

  <!-- Premium non-abonné state -->
  <div
    v-else-if="
      $attrs.type == 'premium' && !$stores.user?.state?.me?.data?.isPremium
    "
    class="flex flex-col items-center justify-center pt-20 pb-12 px-4"
  >
    <div class="w-64 h-64 mb-8">
      <ImgComponent
        src="/images/illustrations/coupons-gift.webp"
        alt="Premium"
        class="w-full h-full object-contain"
      />
    </div>
    <h2 class="text-2xl font-bold title-color mb-2 text-center">
      Coupons Premium
    </h2>
    <p class="text-gray-600 text-center mb-8 max-w-sm">
      Ces coupons exclusifs sont réservés aux membres premium. Abonnez-vous pour
      y accéder.
    </p>
    <button
      @click="
        () => {
          $bus.emit($constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
            title: 'Bientot disponible',
            body: 'Cette foncttionnalité sera bientot disponible'
          });
        }
      "
      class="buttonComponent"
    >
      M'abonner
    </button>
  </div>

  <div
    v-else-if="
      $stores.coupons?.state?.list_all?.list?.filter(
        (c) =>
          !$attrs.type ||
          ($attrs.type == 'premium' ? c.isPremium : !c.isPremium)
      ).length
    "
    class="grid grid-cols-2 gap-4 pt-3 pb-12 px-4 gap-y-12"
  >
    <div
      v-for="(coupon, i) in $stores.coupons?.state?.list_all?.list?.filter(
        (c) =>
          !$attrs.type ||
          ($attrs.type == 'premium' ? c.isPremium : !c.isPremium)
      )"
      :key="i"
      @click="$bus.emit($constants.EVENTS.COUPONS.DETAIL.SHOW, coupon)"
      class="relative block cursor-pointer"
    >
      <div class="py-[70%]"></div>
      <div
        class="absolute w-full h-full top-0 left-0 rounded-2xl shadow-lg overflow-hidden"
      >
        <ImgComponent
          :src="coupon.pictureUrl"
          alt="Coupon"
          class="w-full h-full object-cover"
        />
      </div>
      <div class="absolute top-full left-0 mt-2 w-full text-center text-xl">
        {{ coupon.code }}
      </div>
    </div>
  </div>

  <div
    v-else-if="$stores.coupons?.state?.list_all?.loading"
    class="grid grid-cols-2 gap-4 pt-3 pb-12 px-4 gap-y-12"
  >
    <div v-for="i in 4" :key="i" class="rounded-2xl shimmerContainer relative">
      <div class="w-full shimmerTarget rounded-2xl bg-gray-200">
        <div class="py-[70%]"></div>
      </div>
      <div
        class="absolute top-full left-0 mt-2 w-full text-center text-xl flex justify-center"
      >
        <div class="shimmerTarget rounded-xl">
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        </div>
      </div>
    </div>
  </div>

  <EmptyCoupons
    v-else
    @refresh="() => $bus.emit($constants.EVENTS.COUPONS.LIST_ALL.REFRESH)"
  />
</template>
